import { decode as base64_decode, encode as base64_encode } from "base-64";
import RootStore from "./RootStore";
import { postApi, baseURL } from "../components/Utility";
import { action, get, makeObservable, observable } from "mobx";
import { message } from "antd";
import config from "../config";
class CommandSentReportStore {
  commandSentReport = [];
  total = 0;
  loading = false;
  rootStore;
  // rec = 0;
  constructor(rootStore) {
    makeObservable(this, {
      commandSentReport: observable,
      total: observable,
      loading: observable,
      // rec: observable,
      loadData: action,
      exportExcel: action,
      exportcsv: action,
      exportpdf: action,
      exportxml: action,
    });
    this.rootStore = rootStore;
  }

  async loadData({
    offset,
    limit,
    companyId,
    fromDate,
    toDate,
    vehicleId,
    pageNo,
  }) {
    this.loading = true;
    // console.log("Command Sent Report", vehicleId, pageNo);
    var postData = {
      companyId: companyId,
      vehicleId: vehicleId,
      fromDate: fromDate,
      toDate: toDate,
      offset: offset,
      limit: limit,
      page: pageNo,
    };

    if(config.pythonReport === 1){
      // postData.companyId=10166
        var response = await postApi.getClient('report').post("/admin/commandSent", postData);
    }else{
        const base64Input = await base64_encode(JSON.stringify(postData));
        response = await postApi.getClient().post("index.php?c=vehicle&a=commandreport", "postData=" + base64Input);
    }

    this.total = parseInt(response?.data?.data?.TotalCount);
    console.log("command ", response?.data?.data);

    this.commandSentReport = response?.data?.data?.commandreport;
    this.loading = false;
  }

  async exportExcel(getData) {
    if(config.pythonReport === 1){    
      try {
          var response = await postApi.getClient("report").post("/admin/commandSent/download/excel", getData, {
              responseType: "blob",
          });
      
          const blob = new Blob([response.data], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
      
          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = "Command Sent Report.xlsx";
      
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
    
      } catch (error) {
          message.error("Failed to download the report. Please try again.")
      }

    }else{
      window.location.href =
        baseURL +
        "index.php?c=vehicle&a=exportcommandsentexcel&cid=" +
        getData.companyId +
        "&userId=" +
        getData.userId +
        "&vid=" +
        getData.vehicleId +
        "&fD=" +
        getData.fromDate +
        "&tD=" +
        getData.toDate +
        "&colList=" +
        getData.colList;
    }

  }

  async exportpdf(getData) {

    if(config.pythonReport === 1){    
      try {

        var response = await postApi.getClient("report").post("/admin/commandSent/download/pdf", getData, {
            responseType: "blob",
        });
    
        const blob = new Blob([response.data], {
            type: 'application/pdf'
        });
    
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = "Command Sent Report.pdf";
    
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      
      } catch (error) {
          message.error("Failed to download the report. Please try again.")
      }

    }else{
        window.location.href =
          baseURL +
          "index.php?c=vehicle&a=exportcommandsentpdf&cid=" +
          getData.companyId +
          "&userId=" +
          getData.userId +
          "&vid=" +
          getData.vehicleId +
          "&fD=" +
          getData.fromDate +
          "&tD=" +
          getData.toDate +
          "&colList=" +
          getData.colList;
    }
  }

  async exportcsv(getData) {
    window.location.href =
      baseURL +
      "index.php?c=vehicle&a=exportcommandsentcsv&cid=" +
      getData.companyId +
      "&userId=" +
      getData.userId +
      "&vid=" +
      getData.vehicleId +
      "&fD=" +
      getData.fromDate +
      "&tD=" +
      getData.toDate +
      "&colList=" +
      getData.colList;
  }
  async exportxml(getData) {
    window.location.href =
      baseURL +
      "index.php?c=vehicle&a=exportcommandsentxml&cid=" +
      getData.companyId +
      "&userId=" +
      getData.userId +
      "&vid=" +
      getData.vehicleId +
      "&fD=" +
      getData.fromDate +
      "&tD=" +
      getData.toDate +
      "&colList=" +
      getData.colList;
  }
}

export default CommandSentReportStore;
